import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/Button';

export function UserMenu() {
  const { me, logout } = useAuth();

  return (
    <div className="flex items-center gap-2">
      <span className="hidden text-sm text-muted-foreground sm:inline">{me?.displayName ?? me?.email}</span>
      <Link to="/setup-2fa">
        <Button variant="outline" size="sm">2FA</Button>
      </Link>
      <Button variant="outline" size="sm" onClick={() => { void logout(); }}>
        Salir
      </Button>
    </div>
  );
}
